const eventsData = [
    {
        id: 1,
        title: 'Sunday Service',
        date: 'Every Sundays',
        time: '8.45 a.m.',
        place: 'St. John the Evangelist Church (CNI)',
        image: '/4676.jpg',
        description: "Join us every Sunday for an uplifting worship service.",
        category: 'Special Services'
    },
    
];

export default eventsData;
